"use strict";

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var table_1 = require("msteams-ui-styles-core/lib/components/table");

var React = require("react");

var teams_context_1 = require("../teams-context");

var classes_1 = require("../utils/classes");

var ThInternal = function ThInternal(props) {
  var className = props.className,
      context = props.context,
      rest = __rest(props, ["className", "context"]);

  var themeClassNames = table_1.table(context);
  return React.createElement("th", Object.assign({
    className: classes_1.default(themeClassNames.th, className)
  }, rest), props.children);
};

exports.Th = teams_context_1.connectTeamsComponent(ThInternal);